'use client';
import dynamic from 'next/dynamic';
import HireProcess from '@/components/technologies/hire-process';
import ModelsOfWorking from '@/components/technologies/models-of-working';
// import TechnologyFaq from "@/components/technologies/technology-faq"
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import IpadappServices from '@/components/technologies/ipadapp-services';
import MetaTags from '@/components/meta-tag/meta-tag';
import Blog from '@/components/home/blog';
// import IpadFAQ from "@/components/faqs/ipad-faq"

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const TechHero = dynamic(() => import('@/components/technologies/tech-hero'));
const ContetVideoSection = dynamic(() => import('@/components/common/content-video'));
const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHero
                className=""
                desc="Ensure Futuristic Tablet Solutions for Your Business with Our Premium iPad Application Development Services!"
                alt="iPad Application Development"
                title="iPad Application Development"
                width={1090}
                height={604}
                path={'ipad-hero'}
                bgPath={'hero-bg-grunge-orange'}
                color="orange"
                isOrange={true}
            >
                iPad App Development
            </TechHero>

            <DefaultBreadcrumb parentPage="Technologies" isParent={true} currentPage="ipad App Development" />
            <ContetVideoSection title="Developing Futuristic & Visually Appealing iPad App for Every Business & Industry">
                <>
                    <p className="fw-400 text-secondary fs-md">
                        Notebooks and desktop sales declined gradually since the time iPad came into existence. With a huge number
                        of tablets competing hard in the market to sustain its position, the iPad still tops the list. With an
                        ever-increasing demand of iPad, iPad app development steals the focus of mobile app developers across the
                        globe and thereby settling themselves in new development zone.
                    </p>
                    <p className="fw-400 text-secondary fs-md">
                        Today, there are many iPad app development companies that claim to deliver exceptional yet operational
                        iPad applications but it takes a perfect mixture of creativity, proficiency and frameworks to go for a
                        leading app development company. So, if you’re looking to collaborate with a professional company then
                        we’re your address.
                    </p>
                    <p className="fw-400 text-secondary fs-md mb-0">
                        We are a team of professional and experienced iPad app developers that offers robust iPad solutions within
                        your budget. Whether its iPad Mini series or the original iPad itself, we have it all for you. Using tools
                        like Handoff, Photokit, Touch Id, etc; we expertise in enriching entire experience to the next level. Our
                        applications developed not only suit your business requirement but also meets quality standards without
                        compromising with quality featu
                    </p>
                </>
            </ContetVideoSection>
            <IpadappServices title="Serving Multiple Segments, Our Core iPad App Development Services Include:"></IpadappServices>
            <HireProcess
                bg="bg-ipadeapp"
                pageTitle="Hire Custom iPad Developers To Build Cutting-Edge Digital Products"
                desc="Get a free consultation from our experts who will brainstorm your project idea to convert it into an advanced digital product using iPad."
            />
            <WhyChooseUs pageTitle="Why Clients Choose Moweb for iPad Development?" />
            <ModelsOfWorking
                title="Engagement models to hire the best iPad Developers"
                desc="Select from different engagement models to hire iPad Developers for your business needs. Different types of engagements allow you to find an optimal match for your company's specific needs; whether that means hiring expert developers, or being flexible enough to change when necessary."
            />
            {/* <TechnologyFaq
        title="FAQs On iPad Development"
        bg="bg-ipadeapp"
      >
        <IpadFAQ />
      </TechnologyFaq> */}
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
